// NOTE: This is a hack. Get rid of it once we migrate off of j-toker.
// This is needed because j-toker was designed to be used with AJAX, and automatically
// set request headers. With RTK Query, we'll have to set the headers manually here.
const SAVED_CREDS_KEY = 'authHeaders';

let Auth = null;
if (typeof window === 'object') {
  Auth = require('j-toker/src/j-toker');
}

// eslint-disable-next-line consistent-return
export default function updateHeaders(headers) {
  if (!Auth) return;

  const currentHeaders = Auth.retrieveData(SAVED_CREDS_KEY);
  if (!currentHeaders) return;

  Object.keys(Auth.getConfig().tokenFormat).forEach((key) => {
    headers.set(key, currentHeaders[key]);
  });
}
